import type { PageWindow } from './PaginationControls.types';

const DEFAULT_SIBLING_COUNT = 2;

export function getPageWindow(
  page: number,
  totalItems: number,
  pageSize: number,
  siblingCount: number = DEFAULT_SIBLING_COUNT,
): PageWindow {
  const safePageSize = Math.max(1, pageSize);
  const totalPages = Math.max(1, Math.ceil(totalItems / safePageSize));
  const current = Math.min(Math.max(page, 1), totalPages);

  const start = Math.max(1, current - siblingCount);
  const end = Math.min(totalPages, current + siblingCount);

  const pages: number[] = [];
  for (let p = start; p <= end; p += 1) {
    pages.push(p);
  }

  return {
    pages,
    showLeadingEllipsis: start > 1,
    showTrailingEllipsis: end < totalPages,
    totalPages,
    current,
  };
}
